/**
 * Asynchronously loads the component
 */
import React from 'react';
import Loadable from 'react-loadable';

import SpinnerContainer from '../../components/SpinnerContainer';

export default Loadable({
  loader: () => import(/* webpackChunkName: "CreateListingPage.loadable" */ './index'),
  loading: () => <SpinnerContainer size="lg" height="100vh" />,
});
